import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { categoryModel } from '@/models/privilege/privilege-category'
import router from '@/router'
import store from '@/store'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import useTagList from '@/utils/hooks/useTagList'
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
} from '@vue/composition-api'

export default function usePrivilegeCategoryInfo() {
  const vm = getCurrentInstance().proxy
  const { getDetailCategory, createCategory, EditSubCategory } = categoryModel()

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
  } = useFlatPickr()

  const { fetchTagListData } = useTagList()

  const modeEditor = ref(true)

  const CategoryId = ref(0)
  const loading = ref(false)

  const stepActive = ref(0)

  const checkFormCreateOrEdit = () => {
    modeEditor.value = true

    if (router.currentRoute.params.ref) {
      modeEditor.value = false
      categoryForm.categoryId = parseInt(router.currentRoute.params.ref)
      CategoryId.value = parseInt(router.currentRoute.params.ref)
    }
  }

  const categoryForm = reactive({
    categoryId: 0,
    CategoryLevel: 1,
    nameEn: '',
    nameTh: '',
    Reference: '',
    tag: [],
    status: true,
    image: { file: null, url: null },
    imageSub: { file: null, url: null },
  })

  const optionData = reactive({
    tagList: [],
  })

  const onUploadImage = image => {
    categoryForm.image.file = image.file
    categoryForm.image.url = image.url
  }

  const onUploadImageSub = imageSub => {
    categoryForm.imageSub.file = imageSub.file
    categoryForm.imageSub.url = imageSub.url
  }

  const fetchcategoryDetail = () => {
    window.$loading(true)
    getDetailCategory.payload.Category_Id = categoryForm.categoryId

    store
      .dispatch('api/apiRequest', getDetailCategory)
      .then(response => {
        const respData = response.data.resp
        categoryForm.status = respData.status == 1
        categoryForm.Reference = respData.alt_reference
        categoryForm.nameEn = respData.name_en
        categoryForm.nameTh = respData.name_th
        categoryForm.image.url = respData.category_image_url
        categoryForm.imageSub.url = respData.category_sub_image_url
        categoryForm.tag = respData.tag_list.length > 0
          ? respData.tag_list.map((obj, index) => ({
            seq: index,
            label: obj,
          }))
          : []
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const checkValidform = () => {
    if (categoryForm.nameTh.length <= 0 || categoryForm.nameEn.length <= 0) {
      return false
    }
    return true
  }

  const createCategoryDetail = () => {
    loading.value = true

    let payloadParam = {}

    if (!checkValidform()) {
      loading.value = false
      return
    }

    if (!modeEditor.value) {
      const ePayload = {
        Category_Id: categoryForm.categoryId,
        Name_Th: categoryForm.nameTh,
        Name_En: categoryForm.nameEn,
        Remark: null,
        Category_Image: categoryForm.image.file || '',
        Category_Sub_Image: categoryForm.imageSub.file || '',
        Status: categoryForm.status ? 1 : 2,
        Req_Identity_Id: 1,
        IsImageChange: !!categoryForm.image.file,
        IsSubImageChange: !!categoryForm.imageSub.file,
        Tag_List:
          categoryForm.tag.length > 0 ? categoryForm.tag.map(o => o.label) : [],
      }
      EditSubCategory.payload = ePayload
      payloadParam = EditSubCategory
    } else {
      const cPayload = {
        Category_Level: 1,
        Parent_Category_Id: null,
        Name_Th: categoryForm.nameTh,
        Name_En: categoryForm.nameEn,
        Remark: null,
        Category_Image: categoryForm.image.file || '',
        Category_Sub_Image: categoryForm.imageSub.file || '',
        Status: categoryForm.status ? 1 : 2,
        Req_Identity_Id: 1,
        Tag_List:
          categoryForm.tag.length > 0 ? categoryForm.tag.map(o => o.label) : [],
      }
      createCategory.payload = cPayload
      payloadParam = createCategory
    }

    store
      .dispatch('api/apiFormRequest', payloadParam)
      .then(response => {
        categoryForm.categoryId = response.data.resp.category_id
        router
          .replace(`/privilege/category/info/${categoryForm.categoryId}`)
          .catch(() => {})
        openSuccessModal('ทำรายการสำเร็จ !', null, null, null, () => {
          vm.$emit('onCreateSuccess')
          fetchcategoryDetail()
          nextStep()
        })
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        loading.value = false
      })
  }

  const nextStep = () => {
    window.scrollToTop()
    vm.$emit('onNextStep')
  }

  const fetchTag = () => {
    optionData.tagList = fetchTagListData()
  }

  onBeforeMount(() => {
    checkFormCreateOrEdit()
    fetchTag()
    if (!modeEditor.value) {
      fetchcategoryDetail()
    }
  })

  return {
    loading,
    modeEditor,
    categoryForm,
    CategoryId,
    optionData,
    stepActive,
    onUploadImage,
    onUploadImageSub,
    fetchcategoryDetail,
    createCategoryDetail,
    checkFormCreateOrEdit,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
  }
}
